import { render } from "./MethodAssessmentSchemaPreviewPage.vue?vue&type=template&id=0f88130c"
import script from "./MethodAssessmentSchemaPreviewPage.vue?vue&type=script&lang=js"
export * from "./MethodAssessmentSchemaPreviewPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__